/* * @Author: knight * @Title: 即将上线 * @Date: 2020-04-07 17:57:47 * @Last
Modified by: knight * @Last Modified time: 2020-06-08 12:12:03 */
<template>
  <div class="upComming">
    <BaseUpComming
      :imgWidth="206"
      :imgHeight="275"
      followType="rect"
      :realList="data"
      :clickFollow="clickFollow"
      class="upComming-wrapper block-list"
    >
      <template v-slot:followInfo="followInfoProps">
        <div class="followType-box">
          <div
            class="btn-follow followed"
            @click="clickFollow(followInfoProps.item, 0, $event)"
            v-if="followInfoProps.item.reserved === 1"
          >
            <span>已预约</span>
          </div>

          <div
            class="btn-follow"
            @click="clickFollow(followInfoProps.item, 1, $event)"
            v-else
          >
            <i class="btn-follow-icon"></i>
            <span class="btn-follow-txt">预约</span>
          </div>
        </div>
      </template>
    </BaseUpComming>
  </div>
</template>

<script>
import BaseUpComming from './BaseUpComming'
import http from 'g-public/apis/http'
import cookie from 'g-public/utils/cookie'
import { mapState } from 'vuex'
import { quickLogin } from 'g-public/utils'
import { SENTRY_INITIATIVE_LABEL } from '../enum'
import { sentryInitiativeReport } from 'g-public/utils/sentry'
import { report } from 'g-public/report/index'

export default {
  components: {
    BaseUpComming,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  computed: {
    ...mapState(['isLogin']),
  },
  methods: {
    formatList(list) {
      const slideBorder = this.wideMode ? 7 : 6
      this.disableSlide = list.length < slideBorder
      if (list.length > 0 && list.length < slideBorder) {
        const less = slideBorder - list.length
        for (let i = 0; i < less; i++) {
          list = list.concat({})
        }
      }
      this.list = list
    },

    clickFollow(item, appointmentStatus, e) {
      if (!this.isLogin) {
        return quickLogin()
      }

      // 预约
      report('lectures_preview', { status: appointmentStatus })

      http({
        url:
          appointmentStatus === 1 ?
            'pugv/app/web/reserve/add' :
            'pugv/app/web/reserve/del',
        method: 'post',
        params: {
          id: item.preview_id,
          csrf: cookie.get('bili_jct') || '',
        },
        cookies: true,
      })
        .then(res => {
          if (res.status === 200 && res.data && res.data.code === 0) {
            if (appointmentStatus !== 0) {
              this.$message.info(
                  '课程上线将第一时间收到通知~',
                  e.target.parentElement,
              )
            }

            item.reserved = appointmentStatus
          } else {
            this.$message.info(res.data.message, e.target.parentElement)
          }
          // eslint-disable-next-line handle-callback-err
        })
        .catch(error => {
          sentryInitiativeReport(
              SENTRY_INITIATIVE_LABEL.subscribe,
            appointmentStatus === 1 ? '课程预约失败' : '课程取消预约失败',
            {
              error,
              params: {
                id: item.preview_id,
                csrf: cookie.get('bili_jct') || '',
              },
            },
          )
        })
    },
  },
}
</script>

<style lang="less" scoped>
.followType-box {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 78px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  z-index: 20;
  user-select: none;
}

.btn-follow {
  background: rgba(11, 163, 149, 0.8);
  border-radius: 14px;
  font-size: 14px;
  &:hover {
    background: #0ba395;
    /* border-radius: 18px;
    border-radius: 11px; */
    .btn-follow-icon {
      background: url(../assets/images/classroom/follow-hover.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  &.followed {
    /* opacity: 0.5;
      background: #000000; */
    background: rgba(0, 0, 0, 0.5);
    .btn-follow-icon {
      display: none;
    }
  }
}

.btn-follow-icon {
  display: inline-block;
  vertical-align: middle;
  width: 14px;
  height: 13px;
  background: url(../assets/images/classroom/follow.png) no-repeat;
  background-size: 100% 100%;
}
</style>

<style lang="less">
.coming-soon-wrapper.upComming-wrapper {
  .block-title {
    font-size: 20px;
  }

  .title {
    cursor: pointer;
    font-size: 14px;
    color: #212121;
    height: 44px;
    line-height: 20px;
    width: 206px;
    font-weight: 500;
    position: relative;
  }

  // .info-wrapper:hover {
  //   .title {
  //     color: #0BA395;
  //   }
  // }

  .point {
    width: 10px !important;
    height: 10px !important;

    &.active {
      background: #0ba395;
    }
  }

  .time-line-wrapper {
    height: 38px;

    &.is-today {
      .date {
        color: #212121;
      }

      .point {
        background-color: #0ba395;
      }
    }

    .date {
      font-size: 12px;
      color: #212121;
    }

    .line {
      top: 26px;
    }
  }
}

.btn-follow-txt {
  display: inline-block;
  vertical-align: middle;
}

.upComming {
  padding-top: 20px;
  margin-bottom: 20px;
}
</style>
